import { Box, Text, Modal, ModalHeader, ModalFooter, ModalBody, Button, ButtonAppearance } from '@bechtel/gds';
import { t, Trans } from '@lingui/macro';
import { FC } from 'react';

interface UnsavedChangesDialogProps {
  onClose: (canProceed: boolean) => void;
}

export const UnsavedChangesDialog: FC<UnsavedChangesDialogProps> = ({ onClose }) => {
  return (
    <Modal visible={true} style={{ width: '450px' }}>
      <ModalHeader title={t`Unsaved Changes`}></ModalHeader>
      <ModalBody>
        <Box
          px={{ sm: '500' }}
          py={{ sm: '700' }}
          flexDirection={{ sm: 'column' }}
          // justifyContent={{ sm: 'center' }}
          // alignItems={{ sm: 'center' }}
          flexGrow={{ sm: '1' }}
        >
          <Box mb={{ sm: '500' }}>
            <Text size="500" family="graphik" color="grey.1000" weight="400">
              <Trans>Your have unissued caddies, your changes will be lost once you proceed.</Trans>
            </Text>
          </Box>
          <Box>
            <Text size="500" family="graphik" color="grey.1000" weight="400">
              <Trans>Do you want to proceed?</Trans>
            </Text>
          </Box>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={() => onClose(false)}>
              No, Stay
            </Button>
          </Box>
          <Box>
            <Box mr={{ sm: '400' }}>
              <Button appearance={ButtonAppearance.SECONDARY} onClick={() => onClose(true)}>
                Yes, Proceed
              </Button>
            </Box>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
